import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DemoPage from './pages/DemoPage';
import FAQsPage from './pages/FAQsPage';
import CookieConsent from './components/CookieConsent';
import Footer from './components/Footer';
import CEOLoginPage from './pages/CEOLoginPage';
import EdwardsHamletDemo from './pages/EdwardsHamletDemo';
import EdwardsHamletDashboard from './pages/EdwardsHamletDashboard';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import NotFoundPage from './pages/NotFoundPage';
import PublicationsPage from './pages/PublicationsPage';
import NotOnOurPlatesPage from './pages/NotOnOurPlatesPage';
import REGENCampusPage from './pages/REGENCampusPage';
import UnityBeanPage from './pages/UnityBeanPage';
import MarketInsightsPage from './pages/MarketInsightsPage';
import WaterUnityPage from './pages/WaterUnityPage';
import WaterUnityDashboard from './pages/WaterUnityDashboard';
import BrowserCompatibilityWarning from './components/BrowserCompatibilityWarning';
import { trackPageView } from './utils/analytics';
import { preloadCriticalResources } from './utils/performanceOptimization';
import { getOrganizationSchema } from './utils/seoUtils';

const App: React.FC = () => {
  const location = useLocation();
  
  // Track page views and preload resources
  useEffect(() => {
    // Preload critical resources on initial load
    preloadCriticalResources();
    
    // Track page view when route changes
    trackPageView(location.pathname);
  }, [location.pathname]);
  
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        <meta name="theme-color" content="#9333ea" />
        <link rel="apple-touch-icon" href="/avn-logo-no-bg.png" />
        {/* Performance optimizations */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="preconnect" href="https://images.unsplash.com" />
        {/* Structured data for SEO */}
        <script type="application/ld+json">{getOrganizationSchema()}</script>
      </Helmet>
      <Navbar />
      <CookieConsent />
      <BrowserCompatibilityWarning />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/avn" element={<AboutUs />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/ceo-login" element={<CEOLoginPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/edwards-hamlet" element={<EdwardsHamletDemo />} />
        <Route path="/edwards-hamlet-dashboard" element={<EdwardsHamletDashboard />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/executive-dashboard" element={<ExecutiveDashboard />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/not-on-our-plates" element={<NotOnOurPlatesPage />} />
        <Route path="/education" element={<REGENCampusPage />} />
        <Route path="/market-insights" element={<MarketInsightsPage />} />
        <Route path="/unity-bean" element={<UnityBeanPage />} />
        
        {/* Water Unity Routes */}
        <Route path="/water-unity" element={<WaterUnityPage />} />
        <Route path="/water-unity/dashboard" element={<WaterUnityDashboard />} />
        
        {/* 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;